import $, { data } from 'jquery';
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';

// on load
$( () => {
  if( typeof mapboxCreds !== 'undefined' && $( '.map' ).length ) {
    // Pull Data from PHP ( partials.includes.mapbox-creds )
    // Community Info
    let communityTitle = mapboxCreds.community_location.community_name;
    let communityLong = mapboxCreds.community_location.longitude;
    let communityLat = mapboxCreds.community_location.latitude;
    let communityLink = mapboxCreds.community_location.community_map_link;
    let mapThumbnail = mapboxCreds.community_location.community_thumbnail.url;
  
    // Mapbox Credentials
    let mapboxToken = mapboxCreds.map_credentials.access_token;
    let mapboxStyleURL = mapboxCreds.map_credentials.map_style_url;
    let mapboxUser = mapboxCreds.map_credentials.account_username;
  
    // Mapbox Trails Datasets
    let mapboxTrailsCreated = mapboxCreds.map_credentials.dataset_info.trails_created;
    let mapboxTrailsDatasetID
    let mapboxTrailsDatasetKey
  
    if( mapboxTrailsCreated ) {
      mapboxTrailsDatasetKey = mapboxCreds.map_credentials.dataset_info.dataset_key;
      mapboxTrailsDatasetID = mapboxCreds.map_credentials.dataset_info.dataset_id;
    }
  
    let proximityMarkerColor = mapboxCreds.pin_colors.proximity_color;
  
    mapboxgl.accessToken = mapboxToken;
  
    // Community Marker
    let communityMarker = [ communityLong, communityLat ]
  
    if( $( '#static-map' ).length ) {
      const staticMap = new mapboxgl.Map({
        container: 'static-map', // container ID
        style: mapboxStyleURL, // style URL
        center: communityMarker, // starting position [lng, lat]
        zoom: 13, // starting zoom
        maxZoom: 22,
        cooperativeGestures: true,
      });
  
      let el = document.createElement('div');
      el.className = 'community-marker';
  
      new mapboxgl.Marker( el )
      .setLngLat( communityMarker )
      .addTo( staticMap );
  
      const popup = new mapboxgl.Popup({ 
        closeOnClick: false,
        anchor: 'top',
        offset: [ 0, 24 ],
        closeButton: false
      })
      .setLngLat( communityMarker )
      .setHTML( `<div class="community-thumbnail image-container"> <img src="${ mapThumbnail }" alt="community thumbnail"></div><div class="community-content"><p class="community-title headline-5">${ communityTitle }</p><p class="underline" onclick="window.location='${ communityLink }';" aria-label="link to google maps">Get Directions</p></div>` )
      .addTo( staticMap );
    }

    if( $( '#community-map' ).length ) {
      const communityMap = new mapboxgl.Map({
        container: 'community-map', // container ID
        style: mapboxStyleURL, // style URL
        center: communityMarker, // starting position [lng, lat]
        zoom: 13, // starting zoom
        maxZoom: 22,
        cooperativeGestures: true,
      });

      communityMap.addControl(new mapboxgl.NavigationControl())

      let el = document.createElement('div');
      el.className = 'community-marker';
  
      new mapboxgl.Marker( el )
      .setLngLat( communityMarker )
      .addTo( communityMap );
  
      const popup = new mapboxgl.Popup({ 
        closeOnClick: false,
        anchor: 'top',
        offset: [ 0, 24 ],
        closeButton: false
      })
      .setLngLat( communityMarker )
      .setHTML( `<div class="community-thumbnail image-container"> <img src="${ mapThumbnail }" alt="community thumbnail"></div><div class="community-content"><p class="community-title headline-5">${ communityTitle }</p><p class="underline" onclick="window.location='${ communityLink }';" aria-label="link to google maps">Get Directions</p></div>` )
      .addTo( communityMap );
    }
  
    if( $( '#interactive-map' ).length ) {
  
      const interactiveMap = new mapboxgl.Map({
        container: 'interactive-map', // container ID
        style: mapboxStyleURL, // style URL
        center: communityMarker, // starting position [lng, lat]
        zoom: 13, // starting zoom
        maxZoom: 22,
        cooperativeGestures: true,
      });

      interactiveMap.addControl(new mapboxgl.NavigationControl())
  
      // Community Marker
      let comEl = document.createElement('div');
      comEl.innerHTML = `<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 32C12 32 0 19 0 12C0 5.375 5.375 0 12 0C18.625 0 24 5.375 24 12C24 19 12 32 12 32ZM12 8C10.5625 8 9.25 8.8125 8.5 10C7.8125 11.25 7.8125 12.8125 8.5 14C9.25 15.25 10.5625 16 12 16C13.375 16 14.6875 15.25 15.4375 14C16.125 12.8125 16.125 11.25 15.4375 10C14.6875 8.8125 13.375 8 12 8Z" fill="${ proximityMarkerColor }"/>
                        </svg>`
      comEl.className = 'marker proximity-markers hide';
  
      new mapboxgl.Marker( comEl )
      .setLngLat( communityMarker )
      .addTo( interactiveMap );
  
      // Legend Show/Hide Toggle
      $( '.legend-toggle' ).on( 'click', () => {
        $( '.map-section-wrapper' ).toggleClass( 'legend-closed' )
        $( '.hide-show' ).toggleClass( 'hide' )
        setTimeout( () => {
          interactiveMap.resize();
        }, 300 )
      } )
  
      // Mobile Legend Show/Hide Toggle
      $( '.mobile-toggle, .legend-item' ).on( 'click', () => {
        $( '.mobile-hide-show' ).toggleClass( 'hide' )
        $( '.points-legend' ).toggleClass( 'mobile-show' )
      } )
  
      // Amenities Points
      let amenity = document.querySelectorAll( '.amenity-points' )
  
      amenity.forEach( ( elem ) => {
        let long = elem.dataset.long
        let lat = elem.dataset.lat
        let slug = elem.dataset.slug
        let color = elem.dataset.color
        let title = elem.dataset.title
  
  
        let popup = new mapboxgl.Popup({
          anchor: 'top',
          offset: [ 0, 24 ],
        }).setHTML(
          `<h2 class="headline-6">${ title }</h2>`
        );
  
    
        let el = document.createElement('div');
        el.innerHTML = `<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 32C12 32 0 19 0 12C0 5.375 5.375 0 12 0C18.625 0 24 5.375 24 12C24 19 12 32 12 32ZM12 8C10.5625 8 9.25 8.8125 8.5 10C7.8125 11.25 7.8125 12.8125 8.5 14C9.25 15.25 10.5625 16 12 16C13.375 16 14.6875 15.25 15.4375 14C16.125 12.8125 16.125 11.25 15.4375 10C14.6875 8.8125 13.375 8 12 8Z" fill="${color}"/>
                        </svg>`
        el.dataset.slug = slug
        el.dataset.lat = lat
        el.dataset.long = long
        el.className = 'marker amenities-markers hide';
    
        new mapboxgl.Marker( el )
        .setLngLat( [long, lat] )
        .setPopup(popup)
        .addTo( interactiveMap );
      } )
  
      // Amenity Legend Items
      $( amenity ).on( 'click', function() {
        $( amenity ).removeClass( 'active' )
        $( this ).addClass( 'active' )
  
        $( '#interactive-map .mapboxgl-popup' ).remove();
  
        interactiveMap.flyTo({
          center: [ $( this ).data( 'long' ), $( this ).data( 'lat' ) ],
          essential: true,
          zoom: 15,
          duration: 1000
        })
  
        let popup = new mapboxgl.Popup({ anchor: 'top', offset: [ 0, 24 ], })
        .setLngLat( [ $( this ).data( 'long' ), $( this ).data( 'lat' ) ] )
        .setHTML( `<h2 class="headline-6">${ $( this ).data( 'title' ) }</h2>`)
        .addTo( interactiveMap );
      } )
  
      // Amenities Accordion/Markers functions
      $( '.marker' ).on( 'click', function() {
        let dataSlug = $( this ).data( 'slug' );
        let accordion = $( `.amenity[data-slug='${ dataSlug }']` ).parent().parent()
        let accordionTitle = $( `.amenity[data-slug='${ dataSlug }']` ).parent().prev()
        
        $( amenity ).removeClass( 'active' )
        $( `.amenity[data-slug='${ dataSlug }']` ).addClass( 'active' )
        if( !accordion.hasClass( 'open' ) ) {
          accordionTitle.trigger( 'click' )
        }
      } )
  
      // Get rid of all active classes when map is clicked
      $( '.mapboxgl-canvas' ).on( 'click', () => {
        $( amenity ).removeClass( 'active' )
      } )
  
      // Sort Buttons
      $( '.sort-legend-button' ).on( 'click', function(e) {
        e.preventDefault();
        let sortSlug = $( this ).data( 'sort' )
        
        $( '.legend-container' ).addClass( 'hide' )
        $( `.${sortSlug}-legend` ).removeClass( 'hide' )
  
        $( '.sort-legend-button' ).removeClass( 'hide' );
        $( this ).addClass( 'hide' );
  
        $( '.points-title' ).text( sortSlug )
  
        $( '.marker' ).addClass( 'hide' )
        $( `.${sortSlug}-markers` ).removeClass( 'hide' )
  
        $( '.legend-item' ).removeClass( 'active' )
  
        $( '#interactive-map .mapboxgl-popup' ).remove();
  
        interactiveMap.flyTo({
          center: communityMarker,
          zoom: 13
        })
  
        // Reset Directions
        getRoute( communityMarker );
      } )
  
      // Promixity Points
      let proximityPoints = document.querySelectorAll( '.proximity-points' )
  
      proximityPoints.forEach( ( elem ) => {
        let long = elem.dataset.long
        let lat = elem.dataset.lat
        let slug = elem.dataset.slug
  
        let el = document.createElement('div');
        el.innerHTML = `<svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 32C12 32 0 19 0 12C0 5.375 5.375 0 12 0C18.625 0 24 5.375 24 12C24 19 12 32 12 32ZM12 8C10.5625 8 9.25 8.8125 8.5 10C7.8125 11.25 7.8125 12.8125 8.5 14C9.25 15.25 10.5625 16 12 16C13.375 16 14.6875 15.25 15.4375 14C16.125 12.8125 16.125 11.25 15.4375 10C14.6875 8.8125 13.375 8 12 8Z" fill="${ proximityMarkerColor }"/>
                        </svg>`
        el.dataset.slug = slug
        el.dataset.lat = lat
        el.dataset.long = long
        el.className = 'marker proximity-markers hide';
    
        new mapboxgl.Marker( el )
        .setLngLat( [long, lat] )
        .addTo( interactiveMap );
      } )
  
      // create a function to make a directions request
      async function getRoute(end) {
        // make a directions request using cycling profile
        // an arbitrary start will always be the same
        // only the end or destination will change
        const query = await fetch(
          `https://api.mapbox.com/directions/v5/mapbox/driving/${communityMarker[0]},${communityMarker[1]};${end[0]},${end[1]}?steps=true&geometries=geojson&access_token=${mapboxgl.accessToken}`,
          { method: 'GET' }
        );
        const json = await query.json();
        const data = json.routes[0];
        const route = data.geometry.coordinates;
        const geojson = {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: route
          }
        };
  
        // if the route already exists on the map, we'll reset it using setData
        if (interactiveMap.getSource('route')) {
          interactiveMap.getSource('route').setData(geojson);
        }
        // otherwise, we'll make a new request
        else {
          interactiveMap.addLayer({
            id: 'route',
            type: 'line',
            source: {
              type: 'geojson',
              data: geojson
            },
            layout: {
              'line-join': 'round',
              'line-cap': 'round'
            },
            paint: {
              'line-color': `${ proximityMarkerColor }`,
              'line-width': 5,
              'line-opacity': 0.75
            }
          });
        }
      }
      
      // Promixity Marker Functions
      $( '.proximity-markers, .proximity-points' ).on( 'click', function() {
        let thisLong = $( this ).data( 'long' )
        let thisLat = $( this ).data( 'lat' )
        let coords = [ thisLong, thisLat ];
        let middle = [ ( ( thisLong + Number( communityLong ) ) / 2 ), ( ( thisLat + Number( communityLat ) ) / 2 ) ]
        
        interactiveMap.flyTo( { 
          center: middle,
          zoom: 10.5,
          duration: 1500
        } )
        
        getRoute(coords);
        $( '.proximity-points' ).removeClass( 'active' )
        $( `.proximity-points[data-slug=${ $( this ).data( 'slug' ) }]` ).addClass( 'active' )
      });
  
      // Run Get Route if Promixity
      if( $( '.proximity-legend' ).length ) {
        getRoute(communityMarker);
      }
  
      // Trails Map
      $( '.trail-points' ).on( 'click', function() {
        interactiveMap.flyTo( trailObject[ $( this ).data( 'trail' ) ] )
      } )
  
      let trailObject = {}
  
      const fetchTrailsData = () => {
        fetch( `https://api.mapbox.com/datasets/v1/${ mapboxUser }/${ mapboxTrailsDatasetID }/features?access_token=${ mapboxToken }` )
  
          .then( function( response ){
            // JSON that is returned from the server must be converted to a JS object asynchronously.
            if ( ! response.ok ) {
              throw new Error( 'Not 200 OK' );
            }
            return response.json();
          } )
  
          .then(  function( data ) {
            
            
            data.features.forEach( ( elem ) => {
              let trailName = elem.properties.trail
              let trailStart = elem.geometry.coordinates[0]
              let trailEnd = elem.geometry.coordinates[ elem.geometry.coordinates.length - 1 ]
              let trailCenter = [ ( ( trailStart[0] + trailEnd[0] ) / 2 ), ( ( trailStart[1] + trailEnd[1] ) / 2 ) ]
  
              trailObject[ trailName ] = { center: trailCenter, zoom: 16 }
            } )
  
            return trailObject
          } )
  
          .catch(  function( err ){
            // An error or `reject` from any of the above `.then()` blocks will end up here.
            console.log( err );
          } );
      }
  
      fetchTrailsData();
    }
  
    // Initial Map
    let initialMap = $( '.map-section-wrapper' ).data( 'map' )
    $( `.${ initialMap }-markers` ).removeClass( 'hide' )
  
  }
})